import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { LinearProgress } from '@mui/material';
import { useSnackbar } from 'material-ui-snackbar-provider';

import Modal from '../../modules/Modal';
import { ContainedButton, OutlinedButton } from '../../modules/Buttons';
import styles from './DeleteViewerModal.module.scss';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getSubGroupsByGroupIdThunk } from '../../../store/subGroups/subGroupsSlice';
import { patchGroupViewers } from '../../../api/groupsApi';
import { NOTIFICATION } from '../../../enums/ENUMS';

type TDeleteViewerModal = {
  id: string;
  open: boolean;
  switchModal: () => void;
};

const DeleteViewerModal: React.FC<TDeleteViewerModal> = ({ id, open, switchModal }) => {
  const notification = useSnackbar();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { sort, sortOption } = useAppSelector((state) => state.subGroupsStore);

  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    setLoading(true);
    try {
      await patchGroupViewers(history.location.state as string, { usersToRemove: [id] });
      switchModal();
      dispatch(getSubGroupsByGroupIdThunk({ groupId: history.location.state as string, sort, sortOption }));
    } catch (err) {
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err?.response?.data?.message);
      } else {
        notification.showMessage(NOTIFICATION.NOT_DELETED);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={switchModal} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>Are you sure you want to remove this viewer?</div>
        <div className={styles.form}>
          <div className={styles.actionBtns}>
            <OutlinedButton onClick={handleDelete} kind="default">
              Yes, I am sure
            </OutlinedButton>

            <ContainedButton kind="purple" onClick={switchModal}>
              No, cancel
            </ContainedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteViewerModal;
